import styled from 'styled-components';

export const StyledButton = styled.button`
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
    height: 44px;
    outline: none;
    width: 100%;
    border-radius: 6px;
    border: none;
    font-weight: bold;
    font-size: 12px;
    margin-top: ${({ theme }) => theme.spacing * 15}px;
    cursor: pointer;
`;
